import { useRef, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { MeApi } from 'src/api';
import { ONE_MINUTE, ONE_SECOND } from 'src/constants/times.const';
import { useUserContext } from 'src/context/user';
import { getLanguagePairId } from 'src/utils/language/getLanguagePairId';

export const AppSessionTracker = () => {
  const { user } = useUserContext();
  const languagePairId = useRef<number | null>(null);
  const [isLanguagePairInitialised, setIsLanguagePairInitialised] = useState(false);

  useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: ['submitUserConnectivityStatus'],
    queryFn: async () => {
      languagePairId.current = getLanguagePairId() || languagePairId.current;

      if (!languagePairId.current) {
        return false;
      }

      setIsLanguagePairInitialised(true);
      await MeApi.submitUserConnectivityStatus(languagePairId.current as number);
      return true;
    },
    enabled: !!user,
    refetchInterval: isLanguagePairInitialised ? 10 * ONE_MINUTE : 30 * ONE_SECOND,
  });

  return null;
};
